// axiosSetup.ts
import axios, { isAxiosError } from 'axios';
import { STYRK_API } from 'config';
import { ConnectionError, ForbiddenError } from './customErrors';
import { getUpdatedToken } from 'contexts/AuthProvider';

// Callback que se definirá en un componente React usando hooks
let errorHandlerCallback: ((type: 'network' | 'permissions') => void) | null = null;

export const setAxiosErrorHandler = (cb: (type: 'network' | 'permissions') => void) => {
    errorHandlerCallback = cb;
};

const axiosServices = axios.create({
    ...(STYRK_API && { baseURL: STYRK_API })
});

axiosServices.interceptors.request.use(async (config) => {
    const token = await getUpdatedToken();

    if (token && config && config.headers && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

axiosServices.interceptors.response.use(
    (response) => response,
    async (err) => {
        if (err.response?.status === 403) {
            if (err.response.statusText === 'IP-DomainBlocked') {
                setTimeout(() => {
                    errorHandlerCallback?.('network');
                }, 500);
                throw new ConnectionError();
            } else {
                errorHandlerCallback?.('permissions');
                throw new ForbiddenError();
            }
        }

        return Promise.reject(err);
    }
);

export default axiosServices;

export const logAxiosError = (err: unknown, context: string): never => {
    if (isAxiosError(err)) {
        console.error(`Axios error in ${context}:`, err.response?.status, err.message);
    } else {
        console.error(`Unexpected error in ${context}:`, err);
    }
    throw err;
};
